// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"805":"409e3aa3","820":"d4f4ee90","929":"11c287e9"}[chunkId] + ".css";
};